// src/context/NotificationContext.jsx
import { createContext, useContext, useState } from 'react';

const NotificationContext = createContext(null);

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const addNotification = (message, type = 'info') => {
    const id = Math.random().toString(36).substr(2, 9);
    setNotifications((prev) => [...prev, { id, message, type }]);
    setTimeout(() => {
      setNotifications((prev) => prev.filter((notif) => notif.id !== id));
    }, 5000); 
    if (type == 'error') {
      console.error(message);
    } else {
      console.info(message);
    }
  };

  const icons = {
    'info':'fa-circle-info',
    'success':'fa-check-circle',
    'warn':'fa-triangle-exclamation',
    'error':'fa-circle-exclamation'
  }

  const text_color = {
    'info':'text-blue-500',
    'success':'text-green-500',
    'warn':'text-orange-500',
    'error':'text-red-500'
  }

  const bg_color = {
    'info':'bg-blue-100',
    'success':'bg-green-100',
    'warn':'bg-orange-100',
    'error':'bg-red-100'
  }


  return (
    <NotificationContext.Provider value={{ addNotification }}>
      {children}
      <div className="fixed top-16 right-3 z-50 space-y-1">
        {notifications.map((notif) => (
          <div 
            key={notif.id}
            className={`${bg_color[notif.type]} px-6 py-4 mx-1 my-2 rounded-md text-lg flex items-center mx-auto max-w-lg`}>
            <i className={`fas ${icons[notif.type]} text-l ${text_color[notif.type]}`}></i>
            <span className={`${text_color[notif.type]} mx-2 text-sm`}>{notif.message}</span>
          </div>
        ))}
      </div>
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);